import type { ReactNode } from 'react'
import { Button, Space, Message } from '@arco-design/web-react'
import { IconSave, IconRefresh } from '@arco-design/web-react/icon'
import { formatSaveScopeLabel } from './optionMeta'
import type { OptionsAPI } from './useOptions'

interface Props {
  title: string
  subtitle?: string
  keys: string[]
  options: OptionsAPI
  validate?: () => string | null
  confirmMessage?: string
  hideSave?: boolean
  children: ReactNode
}

/** 单分区轻量容器 + 独立保存 */
export default function SettingSectionCard({
  title,
  subtitle,
  keys,
  options,
  validate,
  confirmMessage,
  hideSave,
  children,
}: Props) {
  const { save, reload, saving } = options

  const submit = async () => {
    if (validate) {
      const msg = validate()
      if (msg) {
        Message.error(msg)
        return
      }
    }
    if (confirmMessage && !window.confirm(confirmMessage)) return
    await save(keys)
  }

  const extra = (
    <Space>
      <Button icon={<IconRefresh />} size="small" onClick={() => reload()}>
        重新加载
      </Button>
      {!hideSave && (
        <Button type="primary" icon={<IconSave />} size="small" loading={saving} onClick={submit}>
          {formatSaveScopeLabel(keys)}
        </Button>
      )}
    </Space>
  )

  return (
    <div className="settings-section mb-3">
      <div className="settings-section-heading">
        <div>
          {title ? <div className="settings-section-title">{title}</div> : null}
          {subtitle ? <div className="settings-section-desc">{subtitle}</div> : null}
        </div>
        <div className="settings-section-extra">{extra}</div>
      </div>
      <div className="settings-section-body">{children}</div>
    </div>
  )
}
